import { useLocale } from '@edreamsodigeo/frontend-core';
import { useCountries } from '@/hooks/GQL';
import { getBrowserDefaultCountry } from '@/components/CountrySelector/CountrySelector';

export function useCountryList() {
  const locale = useLocale();
  const { data, loading, error } = useCountries({ locale });
  const countries = data?.getCountries?.countries;
  const defaultCountry = countries ? getBrowserDefaultCountry(countries) : null;
  return { countries, loading, defaultCountry, error };
}
